<div class="mt-2 position-relative {{ mobToggle ? 'w-50' : '' }} {{ isContractLibrary ? 'AddNewFolderFileContract' : 'AddNewFolderFile' }}">
  <button
    class="_primary-btn d-flex align-items-center addBtn"
    (click)="menu.toggle($event)"
    tooltipPosition="bottom"
    pTooltip="New"
    *ngIf="!hideNewBtn">
    <i [ngClass]="fileUploadingLoader ? 'pi pi-spin pi-spinner' : 'pi pi-plus'" class="f-10 mr-1"></i>
    Add
  </button>
  <p-menu #menu [popup]="true" [model]="newMenuLinks"></p-menu>
  <p-slideMenu #slideMenu [popup]="true" [viewportHeight]="slideMenuViewportHeight" [model]="items"></p-slideMenu>
</div>

<div class="body-details px-0 py-2 mt-2 position-relative" style="border: 0px" *ngIf="propertyId == '' && !hidePropertyLibrary">
  <div class="custom-menu content-container">
    <ng-scrollbar class="vertical-scrollbar" track="vertical" visibility="hover" appearance="compact" style="padding-bottom: 15px">
      <div class="scrollable-content pr-2">
        <div *ngTemplateOutlet="recursiveMenu; context: { $implicit: items }"></div>
      </div>
    </ng-scrollbar>
  </div>
</div>

<ng-template #recursiveMenu let-menus>
  <ul class="level-1 list-unstyled">
    <ng-container *ngFor="let menu of menus; let counter = index">
      <li
        *ngIf="menu?.type === 'folder'"
        id="{{ menu?.label ? menu?.label : counter }}{{ menu?._id }}"
        (click)="sidebarLev1($event, menu, menu?._id ? menu?._id : menu?.label)">
        <a
          class="d-flex align-items-center"
          [ngClass]="{ 'font-size-property-listing py-2 px-2': propertyId?.length > 0 }"
          #anchor
          id="{{ menu?.label ? menu?.label : counter }}{{ menu?._id }}"
          [class.active]="(menu?._id ? menu?._id : menu?.label) == selectedSidebarLink"
          (contextmenu)="menu?._id ? null : rightClickHandler($event, menu)"
          href="javascript:void(0)"
          title="{{ menu?.label }}">
          <span
            *ngIf="isChevronRightIconDisplayed(menu)"
            (click)="onItemSelected($event, menu)"
            class="ml-1 mr-1 pi pi-fw pi-chevron-right pull-right"
            [@indicatorRotate]="expanded[menu?.name ? menu?.name : menu?.label] ? 'expanded' : 'collapsed'">
          </span>
          <span *ngIf="!isChevronRightIconDisplayed(menu) && !menu?.icon" class="pi pi-fw pi-folder pull-right"> </span>&nbsp;
          <ng-container *ngIf="menu?.svg; else icon">
            <img src="{{ menu?.svg }}" alt="icon" class="mr-2" *ngIf="!isChevronRightIconDisplayed(menu)" />
          </ng-container>
          <ng-template #icon>
            <i *ngIf="!isChevronRightIconDisplayed(menu)" class="{{ menu?.icon }}"></i>
          </ng-template>
          <span *ngIf="menu?.label; else notFoundLabel" [ngClass]="{ 'font-size-property-listing': propertyId?.length > 0 }">{{ menu?.label }}</span>
          <ng-template #notFoundLabel>
            <span *ngIf="menu?.name" [ngClass]="{ 'font-size-property-listing': propertyId?.length > 0 }">{{ menu?.name }}</span>
          </ng-template>
        </a>
        <ul *ngIf="(menu?.items || menu?.childrens) && expanded[menu?.name ? menu?.name : menu?.label]" id="nav{{ menu?.name }}">
          <ng-container *ngTemplateOutlet="recursiveMenu; context: { $implicit: menu?.items || menu?.childrens }"> </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>
</ng-template>
